import { environment } from '../../environments/environment';
import { LOGIN_TOKEN_KEY } from '../constants/auth.constants';

export async function runPreAuth(): Promise<boolean> {
  if (!environment.useCiam) {
    return true;
  }

  // Detect hard reloads early and store the result for downstream use
  let isReload = false;
  const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  if (navEntries && navEntries.length > 0) {
    isReload = navEntries[0].type === 'reload';
  } else if ((performance as any).navigation) { // legacy fallback
    isReload = (performance as any).navigation.type === 1;
  }
  try {
    sessionStorage.setItem('IS_PAGE_RELOAD', isReload ? 'true' : 'false');
    if (isReload) {
      sessionStorage.clear(); // drop any stale tokens/data on hard reload
    }
  } catch {}

  const token = sessionStorage.getItem(LOGIN_TOKEN_KEY);
  const isCallback = window.location.pathname.includes('/auth/cim');

  if (!token && !isCallback) {
    if (environment.ciamUrl) {
      window.location.replace(environment.ciamUrl);
      return false;
    }
    return true;
  }

  if (!token && isCallback) {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    if (!code) {
      return true;
    }
    try {
      console.time('[PreAuth] code_exchange');
      const resp = await fetch(`${environment.apiHost}/makpak/auth/code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ authCode: code })
      });
      console.timeEnd('[PreAuth] code_exchange');
      if (resp.ok) {
        const data = await resp.json();
        if (data && data.token) {
          sessionStorage.setItem(LOGIN_TOKEN_KEY, data.token);
          sessionStorage.setItem('CIAM_PREAUTH_DONE', 'true');
          try {
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
          } catch {}
        }
      } else {
        console.warn('[PreAuth] Code exchange failed status', resp.status);
      }
    } catch (e) {
      console.warn('[PreAuth] Code exchange error', e);
    }
    return true;
  }

  sessionStorage.setItem('CIAM_PREAUTH_DONE', 'true');
  return true;
}
